<template>
  <div style="margin-bottom:0px; z-index:200; position:fixed; width:100%;">
    <!--<v-toolbar dense>
      <v-img src="@/assets/TBetMake_Logo-RGB-Hori-noTAG.svg" height="40" width="50" position="left" contain></v-img>-->
    <v-app-bar color="#425058" height="55" style="color: white;" dense app clipped-left>
      <v-img src="@/assets/TBetMake_Logo-controlPanel.png" height="40" width="50" position="left" contain style="padding: 5px;"></v-img>
      <!--<h3 class="controlPanel">Control Panel</h3>-->
      <v-toolbar-items>
        <v-btn v-if="user.roles && (user.roles.includes('*') || userHasResourceAccess(RESOURCENAMES.SILKS) || userHasResourceAccess(RESOURCENAMES.MANAGEMENT)) " to="/race" class="white--text" text>Silks</v-btn>
        <v-btn v-if="user.roles && (user.roles.includes('*') || userHasResourceAccess(RESOURCENAMES.API) || userHasResourceAccess(RESOURCENAMES.MANAGEMENT))" to="/api" class="white--text" style="color:#fff !important;" text>API</v-btn>
        <v-btn v-if="user.roles && (user.roles.includes('*') || userHasResourceAccess(RESOURCENAMES.GRN))" to="/grn" class="white--text" style="color:#fff !important;" text>GRN</v-btn>
        <v-btn v-if="user.roles && (user.roles.includes('*') || userHasResourceAccess(RESOURCENAMES.TERMINALS) || userHasResourceAccess(RESOURCENAMES.MANAGEMENT))" to="/terminals" class="white--text" style="color:#fff !important;" text>Terminals</v-btn>
        <v-btn v-if="user.roles && (user.roles.includes('*') || userHasResourceAccess(RESOURCENAMES.FUTURES) || userHasResourceAccess(RESOURCENAMES.MANAGEMENT))" to="/futures" class="white--text" style="color:#fff !important;" text>Futures</v-btn>
        <v-btn v-if="user.roles && (user.roles.includes('*') || userHasResourceAccess(RESOURCENAMES.SPORTS) || userHasResourceAccess(RESOURCENAMES.MANAGEMENT))" to="/sports" class="white--text" style="color:#fff !important;" text>Sports</v-btn>
        <v-btn v-if="user.roles && (user.roles.includes('*') || userHasResourceAccess(RESOURCENAMES.DO) || userHasResourceAccess(RESOURCENAMES.MANAGEMENT))" to="/do" class="white--text" style="color:#fff !important;" text>DynamicOdds</v-btn>
        <v-btn v-if="user.roles && (user.roles.includes('*')|| userHasResourceAccess(RESOURCENAMES.MANAGEMENT))" to="/audit" class="white--text" style="color:#fff !important;" text>Audit</v-btn>
        <v-btn v-if="user.roles && user.roles.includes('*')" to="/settings" class="white--text" style="color:#fff !important;" text>Settings</v-btn>
        <!--<v-btn text>Features</v-btn>
        <v-btn to="/systemHealth" text>System Health</v-btn>-->
        <v-btn class="font-weight-bold navigation-signin" v-if="!loggedIn" @click="login()" color="#425058" style="color:#fff;" elevation="0"><v-icon class="ml-2">mdi-login</v-icon></v-btn>
        <v-btn class="font-weight-bold navigation-signout" v-else @click="logout()" color="#425058" style="color:#fff;" elevation="0"><v-icon class="ml-2">mdi-logout</v-icon></v-btn>
      </v-toolbar-items>
    </v-app-bar>
    <v-dialog v-model="signInModal" max-width="300px">
      <v-card>
        <v-toolbar color="#425058" dark dense>
          <div class="titleBar-content">
            <v-toolbar-title class="raceResults-title"> Sign In </v-toolbar-title>
            <v-btn class="cancelButton" icon small @click="signInModal = false" ><v-icon class="white--text">mdi-close</v-icon></v-btn>
          </div>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text style="padding: 12px;">
          <span>
            Please <strong @click="login()" style="cursor: pointer;">Sign In</strong> to use Control Panel.
          </span>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { Auth, Hub } from 'aws-amplify';
import { mapActions, mapGetters } from 'vuex'
import { accessControlMixin } from './mixins/index'

export default {
  name: 'AppNavigation',
  mixins: [accessControlMixin],
  props: {
    clickFeature: Function,
    fullScreenMode: Function,
    fullscreen: Boolean
  },
  data: () => ({
    signInModal: false
  }),
  async mounted() {
    Hub.listen("auth", ({payload}) => {
      switch (payload.event) {
        case "signIn":
          this.addApolloClient(this.$apollo)
          Auth.currentAuthenticatedUser().then(user => {
            this.signInModal = false
            //onLogin(this.$apollo.provider.defaultClient, this.accessToken.getJwtToken());
            localStorage.setItem('auth_token', user.getSignInUserSession().getAccessToken().getJwtToken())

            // this.fetchUserFilters()
            this.fetchUser(user).then(()=>this.authState(true)).then(()=>this.auditUIEvent({action:'User SignIn'}))
                        
            // this.fetchRaces()
          });
          break;
        case "signOut":
          this.signInModal = true
          //onLogout(this.$apollo.provider.defaultClient);
          localStorage.removeItem('auth_token')

          this.fetchUser(null)
          this.authState(false)
          this.$disconnect()
          break;
      }
      
    });
    try {
      const user = await Auth.currentAuthenticatedUser();
      //const username = user.username.split('_')[1]
      localStorage.setItem('auth_token', user.getSignInUserSession().getAccessToken().getJwtToken())
      //await this.fetchUserByUsername({ username: username })
      // this.$connect()
      //await onLogin(this.$apollo.provider.defaultClient, this.accessToken.getJwtToken());
    } catch(e) {
      this.$disconnect()
      //await onLogout(this.$apollo.provider.defaultClient);
    }
  },
  computed: {
    ...mapGetters(['getUserLoggedIn','getLoggedIn']),
    user () {
      return this.getUserLoggedIn
    },
    loggedIn(){
      return this.getLoggedIn
    }
  },
  methods: {
    ...mapActions(['addApolloClient', 'authState', 'fetchRaces', 'fetchUserFilters', 'fetchUserByUsername']),
    ...mapActions('account', ['fetchUser']),
    ...mapActions('audit',['auditUIEvent']),
    login: async function() {
      await Auth.federatedSignIn({ provider: 'GoogleSSO' })
    },
    logout: async function() {
      await this.auditUIEvent({action:'User SignOut'})
      Auth.signOut()
    }
  }
}
</script>

<style scoped>
.controlPanel {
  margin-left: 200px;
  position: absolute;
}
</style>
